// extracted by mini-css-extract-plugin
export var dropdownContainer = "_56-5";
export var imageContainer = "_56-4";
export var metricsGrid = "_56-2";
export var productDetailContainer = "_56-1";
export var productListContainer = "_56-0";
export var subscriberTableContainer = "_56-3";